"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreviewCard = void 0;
var react_1 = __importDefault(require("react"));
var styles = __importStar(require("./PreviewCard.css"));
var PreviewCard_css_1 = require("./PreviewCard.css");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var classnames_1 = __importDefault(require("classnames"));
var inversify_react_1 = require("inversify-react");
var dynamic_1 = require("@vanilla-extract/dynamic");
var PreviewCard = function (_a) {
    var _b, _c;
    var heading = _a.heading, explainer = _a.explainer, onClick = _a.onClick, css = _a.css, colors = _a.colors;
    var dataStore = (0, inversify_react_1.useInjection)("censusCollectorStore");
    var logoUrl = dataStore.logoUrls[0];
    return (react_1.default.createElement("div", { className: styles.root },
        react_1.default.createElement(kaleidoscope_1.ButtonCard, { className: (0, classnames_1.default)([styles.card, css.background]), elevation: 1, onClick: onClick },
            react_1.default.createElement("div", { className: (0, classnames_1.default)([styles.contentContainer, css.contentContainer]) },
                react_1.default.createElement("img", { className: css.logo, src: logoUrl, alt: "Logo" }),
                react_1.default.createElement("div", { className: (0, classnames_1.default)([styles.heading, css.heading]), style: (0, dynamic_1.assignInlineVars)((_b = {},
                        _b[PreviewCard_css_1.headingColor] = colors.heading,
                        _b)) }, heading),
                react_1.default.createElement("div", { className: (0, classnames_1.default)([styles.explainer, css.explainer]), style: (0, dynamic_1.assignInlineVars)((_c = {},
                        _c[PreviewCard_css_1.explainerColor] = colors.explainer,
                        _c)) }, explainer)))));
};
exports.PreviewCard = PreviewCard;
